import { render, staticRenderFns } from "./AddCategory.vue?vue&type=template&id=137ef8e1&scoped=true&"
import script from "./AddCategory.vue?vue&type=script&lang=js&"
export * from "./AddCategory.vue?vue&type=script&lang=js&"
import style0 from "./AddCategory.vue?vue&type=style&index=0&id=137ef8e1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137ef8e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('137ef8e1')) {
      api.createRecord('137ef8e1', component.options)
    } else {
      api.reload('137ef8e1', component.options)
    }
    module.hot.accept("./AddCategory.vue?vue&type=template&id=137ef8e1&scoped=true&", function () {
      api.rerender('137ef8e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/helpcenter/pages/categories/AddCategory.vue"
export default component.exports